import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import '../styles/LatestNews.scss';
import Title from './common/Title';

const LatestNewsSkeleton = () => {
  return (
    <div className="latest-news-section">
      <Title text="LATEST NEWS" />
      <div className="container">
        <div className="latest-news-content row">
          {/* LEFT SIDE — Main news skeleton */}
          <div className="main-news-card col-md-6">
            <div className="main-news-image">
              <Skeleton height={300} width="100%" />
              <div className="main-news-info">
                <Skeleton width={100} height={15} />
                <Skeleton width="80%" height={25} />
                <Skeleton width="90%" height={60} />
              </div>
            </div>
          </div>

          {/* RIGHT SIDE — Side news skeletons */}
          <div className="side-news-list col-md-6">
            {Array.from({ length: 3 }).map((_, idx) => (
              <div className="side-news-card small" key={idx}>
                <Skeleton height={150} width="100%" />
                <div className="side-news-info">
                  <Skeleton width="80%" height={20} />
                  <Skeleton width={100} height={15} />
                  <Skeleton width="90%" height={40} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LatestNewsSkeleton;
